import { useEffect, useState } from 'react';

/**
 * useReducedMotion — reactive `prefers-reduced-motion` flag.
 * Every animation primitive checks this; when true, animations become
 * instant state changes (no motion) per WCAG 2.1.
 */
export function useReducedMotion(): boolean {
    const [reduced, setReduced] = useState(
        () => typeof window.matchMedia === 'function'
            ? Boolean(window.matchMedia('(prefers-reduced-motion: reduce)')?.matches)
            : false
    );

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!mq) return;
        const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    return reduced;
}
